import React from 'react';
import { ModalProps } from '~/components/Modal/ModalsGroup';

export interface ILoginModalContext extends ModalProps<'loginRegister'> {}

export const LoginModalContext = React.createContext<ILoginModalContext | null>(
  null,
);
